/**
 * Akkordeon weich auf- und zuklappen (snippets/accordion.liquid).
 *
 * Anlass: Alex, Pastel #30 und #31 (22.09.): "animate the accordion opening and closing within 300ms
 * and easy ease". Der Baustein bleibt ein natives <details>/<summary> (Semantik, Tastatur, Suche im
 * Browser). Animiert wird nur die Hoehe des Inhalts.
 *
 * GOTCHA 1: Ein zugeklapptes <details> versteckt seinen Inhalt sofort - deshalb wird beim Schliessen
 * `open` erst NACH der Animation entfernt, und beim Oeffnen sofort gesetzt.
 * GOTCHA 2: Ein Klick waehrend der Animation darf nicht verschluckt werden (sonst bleibt die Zeile bei
 * schnellem Hin und Her offen stehen - gefunden 2026-09-22 im FAQ-Test). Die laufende Animation wird
 * darum abgebrochen und ab der AKTUELLEN Hoehe in die andere Richtung weitergefuehrt.
 *
 * Gruppen (Pastel #57, PDP): Zeilen mit gleichem data-accordion-group - Oeffnen einer Zeile schliesst
 * die anderen offenen Zeilen der Gruppe (ebenfalls animiert).
 *
 * Ohne JS (oder bei prefers-reduced-motion: reduce) verhaelt sich die Zeile wie vorher: sofort auf/zu.
 */
(function () {
  var DUR = 300;
  var EASE = 'cubic-bezier(0.42, 0, 0.58, 1)'; // "easy ease"
  var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(details) {
    if (details.dataset.accordionReady) return;
    details.dataset.accordionReady = '1';
    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');
    if (!summary || !content) return;
    var running = null;

    /** Aktuelle sichtbare Hoehe des Inhalts (auch mitten in einer Animation). */
    function currentHeight() {
      return content.getBoundingClientRect().height;
    }

    function animate(from, to, done) {
      if (running) {
        running.cancel();
        running = null;
      }
      content.style.overflow = 'hidden';
      var span = Math.abs(to - from);
      var full = Math.max(1, content.scrollHeight);
      // kurzer Weg = kurze Dauer, damit ein Richtungswechsel nicht traege wirkt
      var dur = Math.max(80, Math.round((DUR * span) / full));
      var anim = content.animate(
        [{ height: from + 'px', opacity: from ? 1 : 0 }, { height: to + 'px', opacity: to ? 1 : 0 }],
        { duration: dur, easing: EASE },
      );
      running = anim;
      anim.addEventListener('finish', function () {
        running = null;
        content.style.overflow = '';
        if (done) done();
      });
    }

    function close() {
      if (noMotion.matches) {
        details.open = false;
        return;
      }
      animate(currentHeight(), 0, function () {
        details.open = false;
      });
    }
    details._accordionClose = close;

    /** Andere offene Zeilen derselben Gruppe schliessen. */
    function closeSiblings() {
      var group = details.dataset.accordionGroup;
      if (!group) return;
      document.querySelectorAll('details.accordion[open]').forEach(function (other) {
        if (other === details || other.dataset.accordionGroup !== group) return;
        if (other._accordionClose) other._accordionClose();
        else other.open = false;
      });
    }

    summary.addEventListener('click', function (event) {
      if (noMotion.matches) {
        if (!details.open) closeSiblings();
        return; // Standardverhalten
      }
      event.preventDefault();
      if (!details.open) {
        closeSiblings();
        details.open = true;
        animate(currentHeight(), content.scrollHeight);
      } else {
        close();
      }
    });
  }

  var run = function () {
    document.querySelectorAll('details.accordion').forEach(init);
  };
  run();
  document.addEventListener('shopify:section:load', run);
})();
